import React, { use, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import $ from "jquery";
import jszip from "jszip";
import LZString from "lz-string";

window.JSZip = jszip;

function CandidateList({ setGlobalLoading }) {
  // const location = useLocation();
  // const [candidates, setCandidates] = useState([]);
  const [fullCandidates, setFullCandidates] = useState([]); // Store full data
  const [displayedCandidates, setDisplayedCandidates] = useState([]); // Lazy-loaded data
  const [rowLimit, setRowLimit] = useState(2000);
  useEffect(() => {
    const storedCandidates = localStorage.getItem("candidates");
    // console.log(storedCandidates);
    if (storedCandidates) {
      const decompressedData = JSON.parse(
        LZString.decompressFromUTF16(storedCandidates)
      );
      setFullCandidates(decompressedData); // Store all data
      setDisplayedCandidates(decompressedData.slice(0, rowLimit));
      // console.log(displayedCandidates);
      // setCandidates(decompressedData);
    } else {
      console.log("No candidates found in location state or localStorage.");
    }
  }, [rowLimit]);

  useEffect(() => {
    if (fullCandidates.length > 0) {
      setDisplayedCandidates(fullCandidates.slice(0, rowLimit));
    }
  }, [fullCandidates, rowLimit]);

  useEffect(() => {
    if (displayedCandidates.length > 0) {
      let designations = [
        ...new Set(displayedCandidates.map((c) => c.designation?.trim() || "")),
      ];
      let functions = [
        ...new Set(displayedCandidates.map((c) => c.dutymaster?.trim() || "")),
      ];
      let locations = [
        ...new Set(
          displayedCandidates.map(
            (c) => c.location?.trim() || c.country_name?.trim() || ""
          )
        ),
      ];

      $("#designationFilter").empty();
      $("#functionFilter").empty();
      $("#locationFilter").empty();

      $("#designationFilter").append(new Option("Select Designation", ""));
      $("#functionFilter").append(new Option("Select Function", ""));
      $("#locationFilter").append(new Option("Select Location", ""));

      designations.forEach((designation) => {
        $("#designationFilter").append(new Option(designation, designation));
      });

      functions.forEach((func) => {
        $("#functionFilter").append(new Option(func, func));
      });

      locations.forEach((location) => {
        $("#locationFilter").append(new Option(location, location));
      });

      $("#designationFilter").select2({
        closeOnSelect: false, //  Keep dropdown open for multi-selection
        // minimumInputLength: 2, //  Only search after 10 characters
        placeholder: "Designations",
        allowClear: true,
      });

      $("#functionFilter").select2({
        closeOnSelect: false, //  Keep dropdown open for multi-selection
        // minimumInputLength: 2, //  Only search after 10 characters
        placeholder: "Functions",
        allowClear: true,
      });

      $("#locationFilter").select2({
        closeOnSelect: false, //  Keep dropdown open for multi-selection
        // minimumInputLength: 2, //  Only search after 10 characters
        placeholder: "Locations",
        allowClear: true,
      });

      setTimeout(() => {
        // console.log("updating.....");
        let table = $("#candidateTable").DataTable();
        $("#candidateTable").DataTable({
          destroy: true,
          paging: true,
          searching: true,
          ordering: true,
          info: true,
          scrollX: true,
          fixedHeader: true,
          autoWidth: false,
          responsive: true,
          columnDefs: [
            { width: "35px", targets: 0 },
            { width: "35px", targets: 1 },
            { width: "25px", targets: 2 },
            { width: "85px", targets: 3 },
            { width: "15px", targets: 4 },
            { width: "15px", targets: 5 },
          ],
          lengthMenu: [
            [10, 25, 50, -1],
            [10, 25, 50, "All"],
          ], // ✅ Keeps page count dropdown
          columnDefs: [{ orderable: false, targets: 0 }], // ✅ Disables sorting on first column

          dom:
            "<'row'<'col-md-6'l><'col-md-6'f>>" + // ✅ Keeps search box & row count
            "<'row'<'col-md-12'tr>>" + // ✅ Keeps table structure
            "<'row'<'col-md-5'i><'col-md-7'p>>",
          buttons: [
            {
              extend: "csvHtml5",
              text: "CSV Export",
              title: "Candidates List",
              className: "buttons-csv",
            },
            {
              extend: "excelHtml5",
              text: "Excel Export",
              title: "Candidates List",
              className: "buttons-excel",
            },
          ],
        });
        setTimeout(() => {
          setGlobalLoading(false);
        }, 1000);
        $("#export-csv").on("click", function () {
          table.button(".buttons-csv").trigger();
        });

        $("#export-excel").on("click", function () {
          table.button(".buttons-excel").trigger();
        });

        $("#select-all").on("click", function () {
          let isChecked = this.checked;
          $(".form-check-input").prop("checked", isChecked);
        });

        $(".filter-select").on("change", function () {
          filterTable();
        });
      }, 100);
    }
  }, [displayedCandidates]);

  const loadMoreData = () => {
    setGlobalLoading(true);
    // console.log("Loading more data...");
    try {
      let table = $("#candidateTable").DataTable();
      if ($.fn.DataTable.isDataTable("#candidateTable")) {
        table.destroy(); // Destroy existing table
      }
      const newLimit = rowLimit + 2000; // Load 2000 more rows
      const newCandidates = fullCandidates.slice(rowLimit, newLimit);
      if (newCandidates.length > 0) {
        // Append new data instead of replacing
        setDisplayedCandidates((prev) => [...prev, ...newCandidates]);
        setRowLimit(newLimit);
      } else {
        console.log("No more candidates to load.");
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  useEffect(() => {
    $("#table-view").on("click", function () {
      if ($("#grid-view").hasClass("active")) {
        setGlobalLoading(true);
        $("#grid-view").removeClass("active");
        $("#grid-view").removeClass("bg-primary");
        $("#grid-view").removeClass("text-white");
        $("#grid-view").removeClass("me-1");
        $(".grid-view").addClass("hide");
        $(this).addClass("active");
        $(this).addClass("bg-primary");
        $(this).addClass("text-white");
        $(this).addClass("me-1");
        $(".table-view").removeClass("hide");
        setGlobalLoading(false);
      }
    });

    $("#grid-view").on("click", function () {
      if ($("#table-view").hasClass("active")) {
        setGlobalLoading(true);
        $("#table-view").removeClass("active");
        $("#table-view").removeClass("bg-primary");
        $("#table-view").removeClass("text-white");
        $("#table-view").removeClass("me-1");
        $(".table-view").addClass("hide");
        $(this).addClass("active");
        $(this).addClass("bg-primary");
        $(this).addClass("text-white");
        $(this).addClass("me-1");
        $(".grid-view").removeClass("hide");
        setGlobalLoading(false);
      }
    });
    $(".grid-view").addClass("hide");
  }, []);

  function filterTable() {
    let selectedDesignation = $("#designationFilter").val() || [];
    let selectedFunction = $("#functionFilter").val() || [];
    let selectedLocation = $("#locationFilter").val() || [];

    $("#candidateTable")
      .DataTable()
      .columns(3)
      .search(selectedDesignation.join("|"), true, false)
      .columns(4)
      .search(selectedFunction.join("|"), true, false)
      .columns(5)
      .search(selectedLocation.join("|"), true, false)
      .draw();
  }

  $(".filter-select").on("change", function () {
    filterTable();
  });

  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Candidates List</h2>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
            <div className="me-2 mb-2">
              <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
                <a
                  href="javascript:void(0)"
                  className="btn btn-icon btn-sm active bg-primary text-white me-1"
                  id="table-view"
                >
                  <i className="ti ti-list-tree"></i>
                </a>
                <a
                  href="javascript:void(0)"
                  className="btn btn-icon btn-sm"
                  id="grid-view"
                >
                  <i className="ti ti-layout-grid"></i>
                </a>
              </div>
            </div>
            <div className="me-2 mb-2">
              <div className="dropdown">
                <a
                  href="javascript:void(0);"
                  className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  <i className="ti ti-file-export me-1"></i>Export
                </a>
                <ul className="dropdown-menu  dropdown-menu-end p-3">
                  <li>
                    <a
                      href="javascript:void(0);"
                      className="dropdown-item rounded-1"
                      id="export-excel"
                    >
                      <i className="ti ti-file-type-pdf me-1"></i>Export as
                      Excel
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      className="dropdown-item rounded-1"
                      id="export-csv"
                    >
                      <i className="ti ti-file-type-xls me-1"></i>Export as CSV
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="card table-view">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <h5>
              Candidates List{" "}
              {rowLimit > fullCandidates.length ? (
                <span className="fs-10 text-danger">{`( Showing ${fullCandidates.length} / ${fullCandidates.length} )`}</span>
              ) : (
                <span className="fs-10 text-danger">{`( Showing ${rowLimit} / ${fullCandidates.length} )`}</span>
              )}
              {/* <span className="fs-10 text-danger">{`( Showing ${rowLimit} / ${fullCandidates.length} )`}</span> */}
            </h5>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="dropdown me-3">
                <select
                  id="designationFilter"
                  multiple="multiple"
                  className="filter-select"
                  placeholder="Designation"
                  style={{ width: "30%", marginright: "10px" }}
                ></select>
              </div>
              <div className="dropdown me-3">
                <select
                  id="functionFilter"
                  placeholder="Function"
                  multiple="multiple"
                  className="filter-select"
                  style={{ width: "30%", marginright: "10px" }}
                ></select>
              </div>
              <div className="dropdown">
                <select
                  id="locationFilter"
                  placeholder="Location"
                  multiple="multiple"
                  className="filter-select"
                  style={{ width: "30%" }}
                ></select>
              </div>
              {rowLimit < fullCandidates.length && (
                <div className="text-center mt-3 icons-list">
                  <li style={{ marginTop: "-10px" }}>
                    <i
                      onClick={loadMoreData}
                      className="fe fe-download"
                      data-bs-toggle="tooltip"
                      title="Load More"
                      style={{ cursor: "pointer" }}
                    ></i>
                  </li>
                </div>
              )}
            </div>
          </div>
          <div className="card-body p-0">
            <div className="custom-datatable-filter table-responsive">
              <table
                className="table datatable nowrap"
                style={{ width: "100%" }}
                id="candidateTable"
              >
                <thead className="thead-light">
                  <tr>
                    <th className="no-sort" style={{ width: "10px" }}>
                      <div className="form-check form-check-md">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="select-all"
                        />
                      </div>
                    </th>
                    <th style={{ width: "15px" }}>Full Name</th>
                    <th style={{ width: "15px" }}>Company Name</th>
                    <th style={{ width: "15px" }}>Designation</th>
                    <th style={{ width: "15px" }}>Function</th>
                    <th style={{ width: "15px" }}>Country</th>
                  </tr>
                </thead>
                <tbody>
                  {displayedCandidates.length > 0 ? (
                    displayedCandidates.map((can, index) => (
                      <tr key={index}>
                        <td>
                          <div className="form-check form-check-md">
                            <input
                              className="form-check-input"
                              value={can.candidate_id}
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center file-name-icon">
                            <a
                              href="javascript:void(0)"
                              className="avatar avatar-md border avatar-rounded"
                            >
                              <img
                                src="https://smarthr.dreamstechnologies.com/html/template/assets/img/users/user-39.jpg"
                                className="img-fluid"
                                alt="img"
                              />
                            </a>
                            <div className="ms-2">
                              <h6 className="fw-medium fs-12">
                                <a href="javascript:void(0)">{can.full_name}</a>
                              </h6>
                              <span className="fs-11 fw-normal ">
                                {can.email}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <span className="fs-12 fw-normal">
                            {can.current_company}
                          </span>
                        </td>
                        <td title={can.designation}>
                          <span className="fs-12 fw-normal">
                            {can.designation}
                          </span>
                        </td>
                        <td>
                          <span className="fs-12 fw-normal">
                            {can.dutymaster}
                          </span>
                        </td>

                        <td>
                          <div className="d-flex align-items-center file-name-icon">
                            <div className="ms-2">
                              <h6 className="fw-medium">
                                <span className="fs-12 fw-normal">
                                  {can.country_name}
                                </span>
                              </h6>
                              <span className="fs-11 fw-normal">
                                {can.location}
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No candidates found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* <div className="row grid-view">
          {candidates.length > 0
            ? candidates.map((can, index) => (
                <div key={index} className="col-xl-3 col-lg-4 col-md-6">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div className="form-check form-check-md">
                          <input className="form-check-input" type="checkbox" />
                        </div>
                        <div>
                          <a
                            href="https://smarthr.dreamstechnologies.com/html/template/employee-details.html"
                            className="avatar avatar-xl avatar-rounded online border p-1 border-primary rounded-circle"
                          >
                            <img
                              src="https://smarthr.dreamstechnologies.com/html/template/assets/img/users/user-33.jpg"
                              className="img-fluid h-auto w-auto"
                              alt="img"
                            />
                          </a>
                        </div>
                        <div className="dropdown">
                          <button
                            className="btn btn-icon btn-sm rounded-circle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i className="ti ti-dots-vertical"></i>
                          </button>
                          <ul className="dropdown-menu dropdown-menu-end p-3">
                            <li>
                              <a
                                className="dropdown-item rounded-1"
                                href="javascript:void(0);"
                                data-bs-toggle="modal"
                                data-bs-target="#edit_employee"
                              >
                                <i className="ti ti-edit me-1"></i>Edit
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item rounded-1"
                                href="javascript:void(0);"
                                data-bs-toggle="modal"
                                data-bs-target="#delete_modal"
                              >
                                <i className="ti ti-trash me-1"></i>Delete
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="text-center mb-3">
                        <h6 className="mb-1">
                          <a href="javascript:void(0)">{can.full_name}</a>
                        </h6>
                        <span className="badge badge-dark-transparent fs-9 fw-medium">
                          {can.current_company}
                        </span>
                        <br />
                        <span className="badge badge-dark-transparent fs-8 fw-medium">
                          {can.designation}
                        </span>
                      </div>
                      <div className="row text-center">
                        <div className="col-12">
                          <div className="mb-3">
                            <h6 className="fw-medium fs-11">
                              <span className="fs-12">Function:</span>{" "}
                              <span className="badge badge-purple-transparent">
                                {can.dutymaster}
                              </span>
                            </h6>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="mb-3">
                            <h6 className="fw-medium fs-11">
                              <span className="fs-12">Location: </span>{" "}
                              {can.country_name}
                            </h6>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="mb-3">
                            <h6 className="fw-medium fs-11">
                              <span className="fs-12">Experience: </span> 21+
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            : ""}
          <div className="col-md-12">
            <div className="text-center mb-4">
              <a href="#" className="btn btn-primary">
                <i className="ti ti-loader-3 me-1"></i>Load More
              </a>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
}

export default CandidateList;
